import { render, staticRenderFns } from "./provideAssets.vue?vue&type=template&id=3b4fe1ba&scoped=true&"
import script from "./provideAssets.vue?vue&type=script&lang=js&"
export * from "./provideAssets.vue?vue&type=script&lang=js&"
import style0 from "./provideAssets.vue?vue&type=style&index=0&id=3b4fe1ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4fe1ba",
  null
  
)

export default component.exports